/* import __COLOCATED_TEMPLATE__ from './active-incentive-program-progress.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { ActiveIncentiveProgramProgressRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/client_service';
let ActiveIncentiveProgramProgress = (_class = class ActiveIncentiveProgramProgress extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "bbFrontendClientApi", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _initializerDefineProperty(this, "showProgress", _descriptor3, this);
    _initializerDefineProperty(this, "completed", _descriptor4, this);
    _initializerDefineProperty(this, "title", _descriptor5, this);
    _initializerDefineProperty(this, "description", _descriptor6, this);
    _initializerDefineProperty(this, "daysLeftText", _descriptor7, this);
    _initializerDefineProperty(this, "percentage", _descriptor8, this);
    this.initialize();
  }
  get progressBarStyles() {
    return `width: ${100 * this.percentage}%`;
  }
  async initialize() {
    try {
      const response = await this.bbFrontendClientApi.client.getActiveIncentiveProgramProgress(ActiveIncentiveProgramProgressRequest.create({
        unitToken: this.args.unitToken
      }));

      /**
       * this means that there is no active incentive program for unit and component
       * should stay hidden
       */
      if (!response.incentiveProgram) {
        return;
      }
      const {
        title,
        inProgress,
        completed,
        percentage
      } = response.incentiveProgram;
      this.title = title || '';
      this.percentage = percentage;
      if (completed) {
        this.completed = true;
        this.description = completed.completedText?.html || '';
      } else {
        this.description = inProgress?.progressText || '';
        this.daysLeftText = inProgress?.daysLeftText || '';
      }
      this.showProgress = true;
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bbFrontendClientApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showProgress", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "completed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "title", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "description", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "daysLeftText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "percentage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype)), _class);
export { ActiveIncentiveProgramProgress as default };